import React, { useEffect, useState } from "react";
import api from "../api/axios";
import "../assets/css/PromoPopup.css";
import { useAuth } from "../context/AuthContext";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

const PromoPopup = () => {
    const { isAuthenticated } = useAuth();

    const [campaign, setCampaign] = useState(null);
    const [visible, setVisible] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        fetchCampaign();
    }, []);

    const fetchCampaign = async () => {
        try {
            const res = await api.get(`/campaignRoutes/campaign/active`);

            if (res.data.showPopup) {
                setCampaign(res.data.campaign);
            }
        } catch (err) {
            console.error("Promo fetch failed", err);
        }
    };

    /* ===============================
       SHOW POPUP ONLY AFTER IMAGE LOAD
    =============================== */
    useEffect(() => {
        if (campaign && imageLoaded) {
            setVisible(true);
        }
    }, [campaign, imageLoaded]);

    const markSeen = async (action = "seen") => {
        if (!campaign) return;

        try {
            await api.post(`/campaignRoutes/promo/seen`, {
                campaign_key: campaign.campaign_key,
                action
            });
        } catch (err) {
            console.error("Promo seen failed", err);
        }
    };

    const closePopup = async () => {
        await markSeen("seen");
        setVisible(false);
    };

    const optOut = async () => {
        await markSeen("opt_out");
        setVisible(false);
    };

    if (!campaign) return null;

    return (
        <>
            {/* INVISIBLE IMAGE PRELOAD */}
            {campaign.image_url && !imageLoaded && (
                <img
                    src={campaign.image_url}
                    alt=""
                    style={{ display: "none" }}
                    onLoad={() => setImageLoaded(true)}
                    onError={() => setImageLoaded(true)} // fallback
                />
            )}

            {/* <Dialog
                visible={visible}
                modal
                closable={false}
                dismissableMask
                className="promo-dialog"
                contentClassName="promo-dialog-content"
                style={{ width: "420px", maxWidth: "95vw" }}
                transitionOptions={{ timeout: 300 }}
            >
                
                <Button
                    icon="pi pi-times"
                    className="promo-close p-button-rounded p-button-text"
                    severity="danger"
                    onClick={closePopup}
                    aria-label="Close"
                />

                {campaign.image_url && (
                    <img
                        src={campaign.image_url}
                        alt={campaign.title}
                        className="promo-image"
                    />
                )}

                <h3>{campaign.title}</h3>
                <p>{campaign.body}</p>

                {isAuthenticated && (
                    <div className="promo-actions">
                        {campaign.cta_link && (
                            <Button
                                label={campaign.cta_text || "Learn More"}
                                icon="pi pi-arrow-right"
                                className="p-button-primary"
                                onClick={() => {
                                    markSeen("seen");
                                    window.location.href = campaign.cta_link;
                                }}
                            />
                        )}

                        <Button
                            label="Don’t show again"
                            className="p-button-text p-button-secondary"
                            onClick={optOut}
                        />
                    </div>
                )}
            </Dialog> */}

            <Dialog
                visible={visible}
                modal
                closable={false}
                dismissableMask
                className="promo-dialog"
                contentClassName="promo-dialog-content"
                style={{ width: "900px", maxWidth: "95vw" }}
                transitionOptions={{ timeout: 300 }}
            >
                {/* Close Button */}
                <button className="promo-close" onClick={closePopup} aria-label="Close">
                    ✕
                </button>

                <div className="promo-wrapper">

                    {/* LEFT IMAGE */}
                    <div className="promo-left">
                        {campaign.image_url && (
                            <img
                                src={campaign.image_url}
                                alt={campaign.title}
                            />
                        )}
                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="promo-right">
                        <h2>{campaign.title}</h2>
                        <p>{campaign.body}</p>
                        
                        {isAuthenticated && (
                            <div className="promo-actions d-flex flex-column align-items-center justify-content-center gap-3">
                                {campaign.cta_link && (
                                    <Button
                                        label={campaign.cta_text || "Learn More"}
                                        icon="pi pi-arrow-right"
                                        className="py-2"
                                        outlined
                                        severity="warning"
                                        iconPos="right"
                                        onClick={() => {
                                            markSeen("seen");
                                            window.location.href = campaign.cta_link;
                                        }}
                                    />
                                )}

                                <Button
                                    label="No, Thanks."
                                    className="py-2 px-0"
                                    text
                                    severity="secondary"
                                    onClick={optOut}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default PromoPopup;
